import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useEffect, useState } from "react";
import storePersist from "../../redux/storePersist";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import GetQuote from "../../models/GetQuote";
import ProfileAddress from "../../models/ProfileAddress";
import { selectCurrent as selectUserCurrent } from "../../redux/user/selectors";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";
import _ from 'lodash'
import { settings } from "../../redux/settings/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { leads } from "../../redux/leads/action";
import { selectCmsSettingsListItems } from "../../redux/cmsSettings/selector";
import { cargoLeads } from "../../redux/cargo-lead/action";
import { selectOneConfigurationsQueryItems } from "../../redux/one-configurations/selector";
import { oneConfigurations } from "../../redux/one-configurations/action";
const logoimage = require("../../assets/img/onexbg.png");

const Header = () => {
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const _user = storePersist.get('user')
	const [color, setColor] = useState('universal')
	const result = useSelector(selectCurrent)
	const { header, footer, visible, theme, lightLogo, darkLogo, favIcon, primary, secondary } = result
	const organizationLists = useSelector(selectOrganizationUnitsListItems)
	const { viewProfile } = useSelector(selectUserCurrent)
	const navigate = useNavigate()
	const [logo, setLogo] = useState<any>()
	const cmsSettings = useSelector(selectCmsSettingsListItems)
	const oneConfigurationItems = useSelector(selectOneConfigurationsQueryItems)




	useEffect(() => {
		setLogo(lightLogo || darkLogo)
	}, [result]);
	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}
	const handleProfile = () => {
		navigate('/logistics/profile')
		// dispatch(user.set({ viewProfile: 'open' }))
	}

	const handleMentors = async () => {
		await navigate('/catalyst')
	}

	const handleHome = async () => {
		localStorage.removeItem('access-token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('userProfile')
		await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await navigate('/')
	}
	const handleCargo = async () => {
		localStorage.removeItem('access-token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('userProfile')
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
		await navigate('/cargo')
	}
	const handlePrograms = async () => {
		await navigate('/programs')
	}
	const handleCommunities = async () => {
		await navigate('/communities')
	}
	const handleEvents = async () => {
		await navigate('/events')
	}
	const handleMembership = async () => {
		await navigate('/membership')
	}
	const handleSupport = async () => {
		await navigate('customer/support')
	}

	const handleVentures = async () => {
		await navigate('/venture-view')
	}

	const handlePartner = async () => {
		await navigate('/partner-view')
	}

	const handleAgencies = async () => {
		await navigate('/agencies-view')
	}
	const handleDigiit = async () => {
		await navigate('/digiit')
	}

	const handleDbnNetwork = async () => {
		await navigate('/dbn-network')
	}

	const handleRaiseFrame = async () => {
		await navigate('/raise-frame')
	}

	const handleTestimonial = async () => {
		await navigate('/testimonial')
	}

	const HTMLContent: any = ({ htmlContent }: any) => {
		return (
			<div
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		);
	};


	const fetchOneQueryById = () => {
		dispatch(oneConfigurations.query({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/one/query`, entity: 'oneConfigurations',
			jsonData: {
			}
		}))
	}

	useEffect(
		() => {

			fetchOneQueryById()


		},
		[]
	)
	return (
		<>
			{width && width < 720 ?
				<>


					<header className={`fixed w-screen z-10  flex items-center justify-between px-1 py-1  top-0 h-20 bg-primary`}>
						<div className="flex flex-col w-full justify-start items-center space-y-3 ">
							<div className="flex w-full justify-between items-center py-4 ">
								<div className="flex justify-start items-center text-xl italic uppercase ml-6 " >
									{logo && <img src={logo} className={` w-20 h-12`} />}
								</div>
								<div className="flex flex-col items-center justify-center space-y-1 mx-2">
									<button aria-label="Login" className="p-2 bg-secondary rounded-full" onClick={() => handleNavigate('/auth/login/customer')}>
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="white" fill="none">
											<path d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
											<path d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z" stroke="currentColor" stroke-width="1.5" />
										</svg>
									</button>
									<span className="text-white text-xs">Login</span>
								</div>
								{/* <ul className={`flex  text-light mr-5 rounded-2xl`}>

											<li className="mr-6 p-2">
												<div className="flex flex-col items-center justify-center space-y-1">
													<button aria-label="Login" className="p-2 bg-secondary hover:bg-hilight rounded-full" onClick={() => handleNavigate('/auth/login/customer')}>
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="white" fill="none">
															<path d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
															<path d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z" stroke="currentColor" stroke-width="1.5" />
														</svg>
													</button>
													<span className="text-white hover:text-[#FFB934] text-xs">Login</span>
												</div>
											</li>
											<li className=" px-4 rounded-3xl flex flex-row space-x-1 flex item-center justify-center">
												<svg className="my-3" version="1.1" fill={primary} id="layer" width="18" height="18" viewBox="0 0 612 612">
													<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
		C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
		c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
		 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
		c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
		h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
		c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
		 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
		c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
		c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
		c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
		l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
		c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
		C565.257,281.569,563.532,285.839,560.084,285.839z"/>
												</svg>
												<a className="hover:text-[#FFB934] uppercase text-xs my-3" href="#">Your Cart</a>
											</li>
										</ul> */}
							</div>
						</div>
						<GetQuote />
					</header>

				</>
				: <>

					<div className={`flex flex-col items-center justify-center w-full bg-primary`}>
						<div className="flex items-center text-light justify-between h-16 w-full px-20">
							<div className="flex items-center justify-start">
								{/* Logo */}
								<div className="flex justify-start w-20 h-14">
									{logo && <img src={logo} className="w-full h-14" />}
								</div>

								{/* Navigation - moved slightly right using ml-6 */}
								<ul className="flex cursor-pointer ml-6">
									<li className="mr-2 p-2">
										<a className="hover:opacity-75 text-base" onClick={handleHome}>Home</a>
									</li>

									{cmsSettings?.result?.items?.LogisticsSettings?.Cargo &&
										<li className="mr-2 p-2">
											<a className="hover:opacity-75 text-base" onClick={handleCargo}>Events</a>
										</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowProgramsMenu &&
										<li className="mr-2 p-2">
											<a className="hover:opacity-75 text-base" onClick={handlePrograms}>Programs</a>
										</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowCommunitiesMenu &&
										<li className="mr-2 p-2">
											<a className="hover:opacity-75 text-base" onClick={handleEvents}>Events</a>
										</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowEventsMenu &&
										<li className="mr-2 p-2">
											<a className="hover:opacity-75 text-base" onClick={handleCommunities}>Communities</a>
										</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowEventsMenu &&
										<li className="mr-2 p-2">
											<a className="hover:opacity-75 text-base" onClick={handleMembership}>Membership</a>
										</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowSupportMenu &&
										<li className="mr-2 p-2">
											<a className="hover:opacity-75 text-base" onClick={handleSupport}>Support</a>
										</li>}
								</ul>
							</div>

							<ul className="flex justify-end cursor-pointer">
								{/* <li className="mr-6 hover:opacity-75">
									<svg width="28" height="28" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M5.21467 0.641893C6.01991 0.641893 6.819 0.623452 7.62424 0.648039C9.49903 0.703361 10.4395 1.63154 10.4764 3.49403C10.5071 5.04918 10.71 6.57975 11.1894 8.06114C11.5828 9.27822 11.4353 10.317 10.5747 11.3005C9.8494 12.1304 9.24701 13.0647 8.57085 13.9375C8.27581 14.3186 8.24507 14.6506 8.4848 15.087C10.3289 18.4555 12.9351 21.0494 16.3036 22.8935C16.7216 23.1209 17.0412 23.0963 17.4039 22.8136C18.3689 22.0637 19.3647 21.3445 20.3236 20.5884C21.1104 19.9676 21.9587 19.7893 22.9237 20.0967C24.5219 20.6069 26.157 20.8589 27.8351 20.9081C29.8144 20.9695 30.6934 21.9161 30.718 23.9139C30.7364 25.4014 30.7118 26.8828 30.7241 28.3703C30.7487 30.6447 29.3042 31.4315 27.5646 31.3761C21.8358 31.1917 16.6109 29.5198 11.9762 26.1759C5.15321 21.2584 1.20078 14.5891 0.155818 6.21708C0.0390282 5.22744 0.045175 4.24395 0.0021471 3.2666C-0.0470277 1.96347 0.752063 0.99841 2.03061 0.740242C2.19043 0.709508 2.35024 0.66648 2.50391 0.66648C3.4075 0.660333 4.31109 0.660333 5.21467 0.660333C5.21467 0.654186 5.21467 0.648039 5.21467 0.641893Z" fill="white" />
									</svg>


								</li>
								<li className="mr-6 hover:opacity-75">
									<svg width="28" height="28" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M15.2689 31.2469C12.9024 31.2592 10.6588 30.7306 8.54425 29.6795C8.10782 29.4582 7.71442 29.4336 7.2534 29.5627C5.09586 30.1466 2.93217 30.706 0.768481 31.2777C-0.018316 31.4867 -0.0859332 31.419 0.12306 30.6507C0.694717 28.5546 1.26023 26.4585 1.85647 24.3686C1.9917 23.883 1.96712 23.4835 1.73354 23.0224C-3.11633 13.6239 2.69245 2.3383 13.1605 0.80159C21.4465 -0.415486 29.2837 5.49164 30.4209 13.8083C31.5888 22.3586 25.614 30.1405 17.0822 31.167C16.4737 31.2285 15.8713 31.2162 15.2689 31.2469ZM15.3242 3.14354C13.5539 3.09436 11.8635 3.46318 10.2408 4.15777C3.09199 7.23734 0.295173 15.8368 4.27833 22.5246C4.59182 23.0532 4.66558 23.5081 4.47503 24.0859C4.15539 25.0878 3.90952 26.1143 3.63906 27.1347C3.40548 27.9953 3.43007 28.0198 4.32751 27.7863C5.40935 27.5035 6.49734 27.2453 7.57304 26.9318C8.08938 26.7843 8.50122 26.8519 8.97452 27.1163C11.4087 28.4809 14.0088 29.0402 16.7995 28.696C23.8376 27.8293 28.8043 21.5841 28.0359 14.5459C27.3229 8.03028 21.8706 3.14354 15.3242 3.14354Z" fill="white" />
										<path d="M7.58521 12.5298C7.53603 11.4541 7.91099 10.5506 8.55641 9.72073C9.09734 9.02614 9.78578 8.83558 10.6095 8.92164C11.009 8.96467 11.2241 9.21054 11.3655 9.54247C11.7712 10.4891 12.1585 11.448 12.558 12.4008C12.6748 12.6835 12.6564 12.9417 12.4842 13.1937C12.349 13.3904 12.2199 13.5871 12.0786 13.7715C11.218 14.9025 11.2241 14.9025 12.0601 16.0889C13.2096 17.7116 14.6971 18.8918 16.5104 19.6971C17.1128 19.9675 17.5247 19.8753 17.8996 19.359C18.1516 19.0086 18.459 18.7013 18.7049 18.3509C18.9876 17.9452 19.3257 17.8469 19.7621 18.0497C20.7149 18.4984 21.6615 18.9594 22.6143 19.4143C23.0199 19.611 23.0507 19.9552 23.0015 20.3425C22.8171 21.8608 22.0426 22.6721 20.2416 23.17C19.3626 23.4159 18.4959 23.2438 17.6415 22.9979C14.273 22.0267 11.7097 19.9552 9.63826 17.2014C8.99284 16.3409 8.35971 15.4742 7.96632 14.4538C7.71429 13.833 7.54218 13.1937 7.58521 12.5298Z" fill="white" />
									</svg>

								</li> */}

								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.FrameworkPageMenuConfigurations?.ShowFrameworkPageMenu &&

									<li className="mr-2" onClick={handleRaiseFrame}>
										<div className="flex hover:opacity-75 items-center border-r-2 border-light">
											{/* Login SVG Icon */}

											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.FrameworkPageMenuConfigurations?.FavIcon} />

											{/* Login Text */}
											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.FrameworkPageMenuConfigurations?.MenuName}</span>
										</div>
									</li>}

								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.ShowCloudPageMenu &&

									<li className="mr-2" onClick={handleDigiit}>
										<div className="flex hover:opacity-75 items-center border-r-2 border-light">
											{/* Login SVG Icon */}

											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.FavIcon} />

											{/* Login Text */}
											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.MenuName}</span>
										</div>
									</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.NetworkPageMenuConfigurations?.ShowNetworkPageMenu &&

									<li className="mr-2" onClick={handleDbnNetwork}>
										<div className="flex hover:opacity-75 items-center border-r-2 border-light">
											{/* Login SVG Icon */}

											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.NetworkPageMenuConfigurations?.FavIcon} />

											{/* Login Text */}
											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.NetworkPageMenuConfigurations?.MenuName}</span>
										</div>
									</li>}

									{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.TestimonialPageMenuConfigurations?.ShowTestimonialPageMenu &&

									<li className="mr-2" onClick={handleTestimonial}>
										<div className="flex hover:opacity-75 items-center border-r-2 border-light">
											{/* Login SVG Icon */}

											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.TestimonialPageMenuConfigurations?.FavIcon} />

											{/* Login Text */}
											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.TestimonialPageMenuConfigurations?.MenuName}</span>
										</div>
									</li>}

								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.PartnerMenuConfigurations?.ShowPartnerMenuInHeader &&

									<li className="mr-2" onClick={handlePartner}>
										<div className="flex hover:opacity-75 items-center border-r-2 border-light">
											{/* Login SVG Icon */}

											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.PartnerMenuConfigurations?.FavIcon} />

											{/* Login Text */}
											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.PartnerMenuConfigurations?.MenuName}</span>
										</div>
									</li>}
								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.VenturesMenuConfigurations?.ShowVenturesMenuInHeader &&

									<li className="mr-2 "
										onClick={handleVentures}
									>
										<div className="flex items-center border-r-2 hover:opacity-75 border-light">
											{/* SVG Icon */}
											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.VenturesMenuConfigurations?.FavIcon} />

											{/* Track Text */}
											<span className="pl-3 text-base pr-2" >{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.VenturesMenuConfigurations?.MenuName}</span>
										</div>
									</li>}
								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.AgenciesMenuConfigurations?.ShowAgenciesMenuInHeader &&

									<li className="mr-2" onClick={handleAgencies}>
										<div className="flex  hover:opacity-75 items-center border-r-2 border-light">
											{/* SVG Icon */}
											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.AgenciesMenuConfigurations?.FavIcon} />
											{/* Order Text */}
											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.AgenciesMenuConfigurations?.MenuName}</span>
										</div>
									</li>}

								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.ShowCatalystMenu &&
									<li className="mr-2" onClick={handleMentors}>
										<div className="flex  hover:opacity-75 items-center border-r-2 border-light">
											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.FavIcon} />
											{/* Order Text */}

											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.MenuName}</span>
										</div>


									</li>}


								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.ShowMarketplaceMenuInHeader &&

									<li className="mr-2" onClick={() => window.open(oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.MarketplaceUrl)}>

										<div className="flex  hover:opacity-75 items-center border-r-2 border-light">
											<HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.FavIcon} />
											{/* Order Text */}

											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.MenuName}</span>
										</div>
									</li>}
								<li className="mr-2">
									<div className="flex hover:opacity-75 items-center ">
										{/* Login SVG Icon */}
										<svg width="20" height="20" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => handleNavigate('/oneuser/login')} >
											<path d="M12.8573 12.8571C16.4077 12.8571 19.2859 9.97897 19.2859 6.42857C19.2859 2.87818 16.4077 0 12.8573 0C9.30689 0 6.42871 2.87818 6.42871 6.42857C6.42871 9.97897 9.30689 12.8571 12.8573 12.8571Z" fill="white" />
											<path d="M25.7143 23.5716C25.7143 20.0211 22.8362 17.1431 19.2857 17.1431H6.42857C2.87818 17.1431 0 20.0211 0 23.5716V30.0002H25.7143V23.5716Z" fill="white" />
										</svg>

										{/* Login Text */}
									</div>
								</li>

							</ul>
						</div>
					</div>
				</>
			}
		</>

	)
}
export default Header;